import isFunction from 'lodash/isFunction';
import {
  setExpireTime,
  checkExpireTimeIsUp,
} from '../../scripts/utils/localstorage';

export const initPromoBanner = (bannerName, onClose = null) => {
  const promoBanner =
    document.querySelector(`[data-banner-name="${bannerName}"]`) || null;

  if (promoBanner) {
    const promoBannerHiddenClassName = `promo-banner--hidden`;
    const promoBannerCloseClassName = `promo-banner__close`;
    const bodyLoadedWithPromoClassName = `body--loaded-${bannerName}`;

    if (!checkExpireTimeIsUp(bannerName)) {
      promoBanner.classList.remove(promoBannerHiddenClassName);
      document.body.classList.add(bodyLoadedWithPromoClassName);
    }

    const promoBannerCloseButton = promoBanner.querySelector(
      `.${promoBannerCloseClassName}`
    );

    if (promoBannerCloseButton) {
      promoBannerCloseButton.addEventListener('click', () => {
        setExpireTime(bannerName);

        promoBanner.classList.add(promoBannerHiddenClassName);

        if (onClose && isFunction(onClose)) {
          onClose();
        }
      });
    }
  }

  return true;
};
